// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern Beautiful Design for Objective Modal */

/* Import Google Fonts for better typography */

/* CSS Variables for consistent theming */
:root {
  --primary-color: #F3903F;
  --primary-light: #fbbf24;
  --primary-dark: #d97706;
  --secondary-color: #F3903F;
  --accent-color: #F3903F;
  --success-color: #10b981;
  --warning-color: #f59e0b;
  --error-color: #ef4444;
  --info-color: #3b82f6;
  --text-primary: #1e293b;
  --text-secondary: #475569;
  --text-muted: #64748b;
  --icon-color: #64748b;
  --bg-primary: #ffffff;
  --bg-secondary: #f8fafc;
  --bg-tertiary: #f1f5f9;
  --border-color: #e2e8f0;
  --border-light: #f1f5f9;
  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  --shadow-2xl: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  --gradient-primary: linear-gradient(135deg, #F3903F 0%, #d97706 100%);
  --gradient-secondary: linear-gradient(135deg, #F3903F 0%, #e67e22 100%);
  --gradient-success: linear-gradient(135deg, #10b981 0%, #059669 100%);
  --gradient-warning: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  --gradient-info: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  --gradient-danger: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
}

/* Global Styles */
* {
  box-sizing: border-box;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  line-height: 1.6;
  color: var(--text-primary);
  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);
  min-height: 100vh;
  margin: 0;
  padding: 0;
}

.root {
  margin-top: 80px;
  padding: 1rem;
  width: 100%;
  max-width: 100%;
  margin-left: 0;
  margin-right: 0;
}

/* Header Section */
.roadmap-header {
  background: var(--bg-primary);
  border-radius: 16px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--border-light);
  position: relative;
  overflow: hidden;
  text-align: center;
}

.roadmap-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: var(--gradient-secondary);
  opacity: 0.9;
}

.roadmap-title {
  color: var(--text-primary);
  font-size: 2.5rem;
  font-weight: 700;
  margin: 0 0 1rem 0;
  background: var(--gradient-secondary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.roadmap-subtitle {
  color: var(--text-secondary);
  font-size: 1.125rem;
  font-weight: 500;
  margin: 0;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

/* Compliance Frameworks Section */
.frameworks-section {
  background: var(--bg-primary);
  border-radius: 16px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--border-light);
  position: relative;
  overflow: hidden;
}

.frameworks-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--gradient-info);
  opacity: 0.9;
}

.frameworks-title {
  color: var(--text-primary);
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.frameworks-title::before {
  content: '📋';
  font-size: 1.5rem;
}

.frameworks-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.framework-badge {
  background: var(--gradient-info);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 600;
  border: none;
  box-shadow: var(--shadow-sm);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.framework-badge:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

/* Timeline Section */
.timeline-section {
  background: var(--bg-primary);
  border-radius: 16px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--border-light);
  position: relative;
  overflow: hidden;
}

.timeline-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--gradient-success);
  opacity: 0.9;
}

.timeline-title {
  color: var(--text-primary);
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.timeline-title::before {
  content: '📅';
  font-size: 1.5rem;
}

.timeline-loading {
  text-align: center;
  padding: 3rem 1rem;
}

.timeline-spinner {
  width: 48px;
  height: 48px;
  border: 3px solid var(--border-light);
  border-top: 3px solid var(--secondary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 1rem;
}

.timeline-loading-text {
  color: var(--text-secondary);
  font-size: 1rem;
  font-weight: 500;
  margin: 0;
}

/* Objectives Section */
.objectives-section {
  background: var(--bg-primary);
  border-radius: 16px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--border-light);
  position: relative;
  overflow: hidden;
}

.objectives-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--gradient-warning);
  opacity: 0.9;
}

.objectives-title {
  color: var(--text-primary);
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.objectives-title::before {
  content: '🎯';
  font-size: 1.5rem;
}

.objectives-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 1.5rem;
  width: 100%;
}

/* Objective Card */
.objective-card {
  background: var(--bg-primary);
  border-radius: 12px;
  padding: 1.5rem;
  border: 2px solid var(--border-light);
  box-shadow: var(--shadow-sm);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.objective-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--gradient-secondary);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.objective-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-xl);
  border-color: var(--secondary-color);
}

.objective-card:hover::before {
  opacity: 1;
}

.objective-card.selected {
  border-color: var(--success-color);
  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);
}

.objective-card.selected::before {
  background: var(--gradient-success);
  opacity: 1;
}

.objective-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
}

.objective-title {
  color: var(--text-primary);
  font-size: 1.125rem;
  font-weight: 700;
  margin: 0;
  line-height: 1.4;
  flex: 1 1;
  margin-right: 1rem;
}

.priority-badge {
  padding: 0.375rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  box-shadow: var(--shadow-sm);
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.priority-badge.high {
  background: var(--gradient-danger);
  color: white;
}

.priority-badge.medium {
  background: var(--gradient-warning);
  color: white;
}

.objective-description {
  color: var(--text-secondary);
  font-size: 0.875rem;
  line-height: 1.6;
  margin-bottom: 1rem;
}

.objective-meta {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.8rem;
  color: var(--text-muted);
}

.meta-icon {
  width: 16px;
  height: 16px;
  opacity: 0.7;
}

.objective-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 1rem;
  border-top: 1px solid var(--border-light);
}

.objective-reference {
  color: var(--text-muted);
  font-size: 0.75rem;
  font-weight: 500;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.select-button {
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-size: 0.8rem;
  font-weight: 600;
  border: 2px solid;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 80px;
}

.select-button.selected {
  background: var(--gradient-success);
  color: white;
  border-color: var(--success-color);
}

.select-button.selected:hover {
  transform: scale(1.05);
  box-shadow: var(--shadow-md);
}

.select-button:not(.selected) {
  background: transparent;
  color: var(--text-secondary);
  border-color: var(--border-color);
}

.select-button:not(.selected):hover {
  background: var(--bg-secondary);
  border-color: var(--secondary-color);
  color: var(--secondary-color);
}

/* Confirmation Section */
.confirmation-section {
  background: var(--bg-primary);
  border-radius: 16px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--border-light);
  position: relative;
  overflow: hidden;
}

.confirmation-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--gradient-success);
  opacity: 0.9;
}

.confirmation-checkbox {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  padding: 1rem;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.confirmation-checkbox:hover {
  background: var(--bg-secondary);
}

.confirmation-checkbox input[type="checkbox"] {
  width: 20px;
  height: 20px;
  accent-color: var(--success-color);
  cursor: pointer;
}

.confirmation-checkbox label {
  color: var(--text-primary);
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  margin: 0;
}

/* Action Buttons */
.action-buttons {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
}

.build-roadmap-button {
  background: var(--gradient-success);
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 12px;
  font-size: 1.125rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: var(--shadow-md);
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-width: 200px;
}

.build-roadmap-button:hover {
  transform: translateY(-3px);
  box-shadow: var(--shadow-xl);
  color: white;
  text-decoration: none;
}

.build-roadmap-button::before {
  content: '🚀';
  font-size: 1.25rem;
}

/* Loading States */
.loading-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  gap: 2rem;
  background: var(--bg-primary);
  border-radius: 16px;
  padding: 3rem;
  box-shadow: var(--shadow-lg);
  width: 100%;
  text-align: center;
}

.loading-spinner {
  width: 64px;
  height: 64px;
  border: 4px solid var(--border-light);
  border-top: 4px solid var(--secondary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  box-shadow: var(--shadow-md);
}

.loading-title {
  color: var(--text-primary);
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
}

.loading-subtitle {
  color: var(--text-secondary);
  font-size: 1.125rem;
  font-weight: 500;
  margin: 0;
  max-width: 400px;
  line-height: 1.6;
}

/* Empty State */
.empty-state {
  background: var(--bg-primary);
  border-radius: 16px;
  padding: 3rem 2rem;
  text-align: center;
  color: var(--text-muted);
  border: 2px dashed var(--border-color);
  width: 100%;
  box-shadow: var(--shadow-sm);
}

.empty-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
  opacity: 0.5;
}

.empty-title {
  color: var(--text-primary);
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.empty-description {
  font-size: 1rem;
  font-weight: 500;
  margin: 0;
  max-width: 500px;
  margin: 0 auto;
  line-height: 1.6;
}

/* Animations */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

/* Apply animations */
.roadmap-header {
  animation: fadeInUp 0.6s ease-out;
}

.frameworks-section {
  animation: slideInLeft 0.6s ease-out 0.1s both;
}

.timeline-section {
  animation: slideInLeft 0.6s ease-out 0.2s both;
}

.objectives-section {
  animation: slideInLeft 0.6s ease-out 0.3s both;
}

.confirmation-section {
  animation: slideInLeft 0.6s ease-out 0.4s both;
}

.objective-card {
  animation: fadeInUp 0.6s ease-out;
}

/* Enhanced Hover Effects */
.objective-card:hover .priority-badge {
  animation: pulse 0.6s ease-in-out;
}

.framework-badge:hover {
  animation: pulse 0.6s ease-in-out;
}

/* Responsive Design */
@media (max-width: 768px) {
  .root {
    margin-top: 60px;
    padding: 0.5rem;
  }
  
  .roadmap-header {
    padding: 1.5rem;
    margin-bottom: 1.5rem;
  }
  
  .roadmap-title {
    font-size: 2rem;
  }
  
  .roadmap-subtitle {
    font-size: 1rem;
  }
  
  .objectives-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .objective-card {
    padding: 1.25rem;
  }
  
  .action-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .build-roadmap-button {
    width: 100%;
    max-width: 300px;
  }
}

@media (max-width: 480px) {
  .root {
    padding: 0.25rem;
  }
  
  .roadmap-header {
    padding: 1rem;
  }
  
  .roadmap-title {
    font-size: 1.75rem;
  }
  
  .frameworks-section,
  .timeline-section,
  .objectives-section,
  .confirmation-section {
    padding: 1rem;
  }
  
  .objective-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }
  
  .objective-title {
    margin-right: 0;
  }
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
  :root {
    --bg-primary: #1f2937;
    --bg-secondary: #111827;
    --bg-tertiary: #374151;
    --text-primary: #f9fafb;
    --text-secondary: #d1d5db;
    --text-muted: #9ca3af;
    --icon-color: #9ca3af;
    --border-color: #374151;
    --border-light: #4b5563;
  }
  
  body {
    background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
  }
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: var(--bg-tertiary);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: var(--secondary-color);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--accent-color);
}
`, "",{"version":3,"sources":["webpack://./src/pages/Objective/objectiveModal.css"],"names":[],"mappings":"AAAA,gDAAgD;;AAEhD,8CAA8C;;AAG9C,yCAAyC;AACzC;EACE,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;EAC1B,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,4CAA4C;EAC5C,kFAAkF;EAClF,oFAAoF;EACpF,sFAAsF;EACtF,mDAAmD;EACnD,qEAAqE;EACrE,uEAAuE;EACvE,qEAAqE;EACrE,qEAAqE;EACrE,kEAAkE;EAClE,oEAAoE;AACtE;;AAEA,kBAAkB;AAClB;EACE,sBAAsB;AACxB;;AAEA;EACE,uFAAuF;EACvF,gBAAgB;EAChB,0BAA0B;EAC1B,6DAA6D;EAC7D,iBAAiB;EACjB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,4BAA4B;EAC5B,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,iDAAiD;AACnD;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,qBAAqB;AACrB;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,4BAA4B;EAC5B,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,4CAA4C;EAC5C,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,4BAA4B;EAC5B,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,qCAAqC;EACrC,4BAA4B;EAC5B,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,qCAAqC;EACrC,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,6DAA6D;AAC/D;;AAEA;EACE,mCAAmC;EACnC,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA,yBAAyB;AACzB;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,4BAA4B;EAC5B,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,4BAA4B;EAC5B,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,4BAA4B;EAC5B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,4CAA4C;EAC5C,kBAAkB;EAClB,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,sCAAsC;EACtC,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA,qBAAqB;AACrB;EACE,iCAAiC;AACnC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,iCAAiC;AACnC;;AAEA,2BAA2B;AAC3B;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,sBAAsB;AACtB;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;;IAIE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,qBAAqB;IACrB,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;IACrB,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,6DAA6D;EAC/D;AACF;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC","sourcesContent":["/* Modern Beautiful Design for Objective Modal */\n\n/* Import Google Fonts for better typography */\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');\n\n/* CSS Variables for consistent theming */\n:root {\n  --primary-color: #F3903F;\n  --primary-light: #fbbf24;\n  --primary-dark: #d97706;\n  --secondary-color: #F3903F;\n  --accent-color: #F3903F;\n  --success-color: #10b981;\n  --warning-color: #f59e0b;\n  --error-color: #ef4444;\n  --info-color: #3b82f6;\n  --text-primary: #1e293b;\n  --text-secondary: #475569;\n  --text-muted: #64748b;\n  --icon-color: #64748b;\n  --bg-primary: #ffffff;\n  --bg-secondary: #f8fafc;\n  --bg-tertiary: #f1f5f9;\n  --border-color: #e2e8f0;\n  --border-light: #f1f5f9;\n  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  --shadow-2xl: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  --gradient-primary: linear-gradient(135deg, #F3903F 0%, #d97706 100%);\n  --gradient-secondary: linear-gradient(135deg, #F3903F 0%, #e67e22 100%);\n  --gradient-success: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  --gradient-warning: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n  --gradient-info: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\n  --gradient-danger: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);\n}\n\n/* Global Styles */\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  line-height: 1.6;\n  color: var(--text-primary);\n  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);\n  min-height: 100vh;\n  margin: 0;\n  padding: 0;\n}\n\n.root {\n  margin-top: 80px;\n  padding: 1rem;\n  width: 100%;\n  max-width: 100%;\n  margin-left: 0;\n  margin-right: 0;\n}\n\n/* Header Section */\n.roadmap-header {\n  background: var(--bg-primary);\n  border-radius: 16px;\n  padding: 2rem;\n  margin-bottom: 2rem;\n  box-shadow: var(--shadow-lg);\n  border: 1px solid var(--border-light);\n  position: relative;\n  overflow: hidden;\n  text-align: center;\n}\n\n.roadmap-header::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: var(--gradient-secondary);\n  opacity: 0.9;\n}\n\n.roadmap-title {\n  color: var(--text-primary);\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin: 0 0 1rem 0;\n  background: var(--gradient-secondary);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.roadmap-subtitle {\n  color: var(--text-secondary);\n  font-size: 1.125rem;\n  font-weight: 500;\n  margin: 0;\n  max-width: 600px;\n  margin: 0 auto;\n  line-height: 1.6;\n}\n\n/* Compliance Frameworks Section */\n.frameworks-section {\n  background: var(--bg-primary);\n  border-radius: 16px;\n  padding: 1.5rem;\n  margin-bottom: 2rem;\n  box-shadow: var(--shadow-lg);\n  border: 1px solid var(--border-light);\n  position: relative;\n  overflow: hidden;\n}\n\n.frameworks-section::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: var(--gradient-info);\n  opacity: 0.9;\n}\n\n.frameworks-title {\n  color: var(--text-primary);\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.frameworks-title::before {\n  content: '📋';\n  font-size: 1.5rem;\n}\n\n.frameworks-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n\n.framework-badge {\n  background: var(--gradient-info);\n  color: white;\n  padding: 0.5rem 1rem;\n  border-radius: 20px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  border: none;\n  box-shadow: var(--shadow-sm);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.framework-badge:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n/* Timeline Section */\n.timeline-section {\n  background: var(--bg-primary);\n  border-radius: 16px;\n  padding: 1.5rem;\n  margin-bottom: 2rem;\n  box-shadow: var(--shadow-lg);\n  border: 1px solid var(--border-light);\n  position: relative;\n  overflow: hidden;\n}\n\n.timeline-section::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: var(--gradient-success);\n  opacity: 0.9;\n}\n\n.timeline-title {\n  color: var(--text-primary);\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.timeline-title::before {\n  content: '📅';\n  font-size: 1.5rem;\n}\n\n.timeline-loading {\n  text-align: center;\n  padding: 3rem 1rem;\n}\n\n.timeline-spinner {\n  width: 48px;\n  height: 48px;\n  border: 3px solid var(--border-light);\n  border-top: 3px solid var(--secondary-color);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 1rem;\n}\n\n.timeline-loading-text {\n  color: var(--text-secondary);\n  font-size: 1rem;\n  font-weight: 500;\n  margin: 0;\n}\n\n/* Objectives Section */\n.objectives-section {\n  background: var(--bg-primary);\n  border-radius: 16px;\n  padding: 1.5rem;\n  margin-bottom: 2rem;\n  box-shadow: var(--shadow-lg);\n  border: 1px solid var(--border-light);\n  position: relative;\n  overflow: hidden;\n}\n\n.objectives-section::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: var(--gradient-warning);\n  opacity: 0.9;\n}\n\n.objectives-title {\n  color: var(--text-primary);\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin-bottom: 1.5rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.objectives-title::before {\n  content: '🎯';\n  font-size: 1.5rem;\n}\n\n.objectives-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n  gap: 1.5rem;\n  width: 100%;\n}\n\n/* Objective Card */\n.objective-card {\n  background: var(--bg-primary);\n  border-radius: 12px;\n  padding: 1.5rem;\n  border: 2px solid var(--border-light);\n  box-shadow: var(--shadow-sm);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  overflow: hidden;\n}\n\n.objective-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: var(--gradient-secondary);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.objective-card:hover {\n  transform: translateY(-4px);\n  box-shadow: var(--shadow-xl);\n  border-color: var(--secondary-color);\n}\n\n.objective-card:hover::before {\n  opacity: 1;\n}\n\n.objective-card.selected {\n  border-color: var(--success-color);\n  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);\n}\n\n.objective-card.selected::before {\n  background: var(--gradient-success);\n  opacity: 1;\n}\n\n.objective-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 1rem;\n}\n\n.objective-title {\n  color: var(--text-primary);\n  font-size: 1.125rem;\n  font-weight: 700;\n  margin: 0;\n  line-height: 1.4;\n  flex: 1;\n  margin-right: 1rem;\n}\n\n.priority-badge {\n  padding: 0.375rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  box-shadow: var(--shadow-sm);\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.priority-badge.high {\n  background: var(--gradient-danger);\n  color: white;\n}\n\n.priority-badge.medium {\n  background: var(--gradient-warning);\n  color: white;\n}\n\n.objective-description {\n  color: var(--text-secondary);\n  font-size: 0.875rem;\n  line-height: 1.6;\n  margin-bottom: 1rem;\n}\n\n.objective-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.meta-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.8rem;\n  color: var(--text-muted);\n}\n\n.meta-icon {\n  width: 16px;\n  height: 16px;\n  opacity: 0.7;\n}\n\n.objective-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 1rem;\n  border-top: 1px solid var(--border-light);\n}\n\n.objective-reference {\n  color: var(--text-muted);\n  font-size: 0.75rem;\n  font-weight: 500;\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.select-button {\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  border: 2px solid;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 80px;\n}\n\n.select-button.selected {\n  background: var(--gradient-success);\n  color: white;\n  border-color: var(--success-color);\n}\n\n.select-button.selected:hover {\n  transform: scale(1.05);\n  box-shadow: var(--shadow-md);\n}\n\n.select-button:not(.selected) {\n  background: transparent;\n  color: var(--text-secondary);\n  border-color: var(--border-color);\n}\n\n.select-button:not(.selected):hover {\n  background: var(--bg-secondary);\n  border-color: var(--secondary-color);\n  color: var(--secondary-color);\n}\n\n/* Confirmation Section */\n.confirmation-section {\n  background: var(--bg-primary);\n  border-radius: 16px;\n  padding: 1.5rem;\n  margin-bottom: 2rem;\n  box-shadow: var(--shadow-lg);\n  border: 1px solid var(--border-light);\n  position: relative;\n  overflow: hidden;\n}\n\n.confirmation-section::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: var(--gradient-success);\n  opacity: 0.9;\n}\n\n.confirmation-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  cursor: pointer;\n  padding: 1rem;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n}\n\n.confirmation-checkbox:hover {\n  background: var(--bg-secondary);\n}\n\n.confirmation-checkbox input[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n  accent-color: var(--success-color);\n  cursor: pointer;\n}\n\n.confirmation-checkbox label {\n  color: var(--text-primary);\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  margin: 0;\n}\n\n/* Action Buttons */\n.action-buttons {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  margin-top: 2rem;\n}\n\n.build-roadmap-button {\n  background: var(--gradient-success);\n  color: white;\n  border: none;\n  padding: 1rem 2rem;\n  border-radius: 12px;\n  font-size: 1.125rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: var(--shadow-md);\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  min-width: 200px;\n}\n\n.build-roadmap-button:hover {\n  transform: translateY(-3px);\n  box-shadow: var(--shadow-xl);\n  color: white;\n  text-decoration: none;\n}\n\n.build-roadmap-button::before {\n  content: '🚀';\n  font-size: 1.25rem;\n}\n\n/* Loading States */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-height: 60vh;\n  gap: 2rem;\n  background: var(--bg-primary);\n  border-radius: 16px;\n  padding: 3rem;\n  box-shadow: var(--shadow-lg);\n  width: 100%;\n  text-align: center;\n}\n\n.loading-spinner {\n  width: 64px;\n  height: 64px;\n  border: 4px solid var(--border-light);\n  border-top: 4px solid var(--secondary-color);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  box-shadow: var(--shadow-md);\n}\n\n.loading-title {\n  color: var(--text-primary);\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 0 0 0.5rem 0;\n}\n\n.loading-subtitle {\n  color: var(--text-secondary);\n  font-size: 1.125rem;\n  font-weight: 500;\n  margin: 0;\n  max-width: 400px;\n  line-height: 1.6;\n}\n\n/* Empty State */\n.empty-state {\n  background: var(--bg-primary);\n  border-radius: 16px;\n  padding: 3rem 2rem;\n  text-align: center;\n  color: var(--text-muted);\n  border: 2px dashed var(--border-color);\n  width: 100%;\n  box-shadow: var(--shadow-sm);\n}\n\n.empty-icon {\n  font-size: 3rem;\n  margin-bottom: 1rem;\n  opacity: 0.5;\n}\n\n.empty-title {\n  color: var(--text-primary);\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n}\n\n.empty-description {\n  font-size: 1rem;\n  font-weight: 500;\n  margin: 0;\n  max-width: 500px;\n  margin: 0 auto;\n  line-height: 1.6;\n}\n\n/* Animations */\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideInLeft {\n  from {\n    opacity: 0;\n    transform: translateX(-30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes pulse {\n  0%, 100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n}\n\n/* Apply animations */\n.roadmap-header {\n  animation: fadeInUp 0.6s ease-out;\n}\n\n.frameworks-section {\n  animation: slideInLeft 0.6s ease-out 0.1s both;\n}\n\n.timeline-section {\n  animation: slideInLeft 0.6s ease-out 0.2s both;\n}\n\n.objectives-section {\n  animation: slideInLeft 0.6s ease-out 0.3s both;\n}\n\n.confirmation-section {\n  animation: slideInLeft 0.6s ease-out 0.4s both;\n}\n\n.objective-card {\n  animation: fadeInUp 0.6s ease-out;\n}\n\n/* Enhanced Hover Effects */\n.objective-card:hover .priority-badge {\n  animation: pulse 0.6s ease-in-out;\n}\n\n.framework-badge:hover {\n  animation: pulse 0.6s ease-in-out;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .root {\n    margin-top: 60px;\n    padding: 0.5rem;\n  }\n  \n  .roadmap-header {\n    padding: 1.5rem;\n    margin-bottom: 1.5rem;\n  }\n  \n  .roadmap-title {\n    font-size: 2rem;\n  }\n  \n  .roadmap-subtitle {\n    font-size: 1rem;\n  }\n  \n  .objectives-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n  \n  .objective-card {\n    padding: 1.25rem;\n  }\n  \n  .action-buttons {\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .build-roadmap-button {\n    width: 100%;\n    max-width: 300px;\n  }\n}\n\n@media (max-width: 480px) {\n  .root {\n    padding: 0.25rem;\n  }\n  \n  .roadmap-header {\n    padding: 1rem;\n  }\n  \n  .roadmap-title {\n    font-size: 1.75rem;\n  }\n  \n  .frameworks-section,\n  .timeline-section,\n  .objectives-section,\n  .confirmation-section {\n    padding: 1rem;\n  }\n  \n  .objective-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.75rem;\n  }\n  \n  .objective-title {\n    margin-right: 0;\n  }\n}\n\n/* Dark mode support */\n@media (prefers-color-scheme: dark) {\n  :root {\n    --bg-primary: #1f2937;\n    --bg-secondary: #111827;\n    --bg-tertiary: #374151;\n    --text-primary: #f9fafb;\n    --text-secondary: #d1d5db;\n    --text-muted: #9ca3af;\n    --icon-color: #9ca3af;\n    --border-color: #374151;\n    --border-light: #4b5563;\n  }\n  \n  body {\n    background: linear-gradient(135deg, #1f2937 0%, #111827 100%);\n  }\n}\n\n/* Custom scrollbar */\n::-webkit-scrollbar {\n  width: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: var(--bg-tertiary);\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--secondary-color);\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--accent-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
